import { Icon } from "@chakra-ui/react";

export default function Play({ ...props }) {
  return (
    <Icon
      width={props.size || "32px"}
      height={props.size || "32px"}
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="currentColor"
        d="M16,-1.0658141e-14 C7.163444,-1.0658141e-14 7.10542736e-15,7.163444 7.10542736e-15,16 C7.10542736e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,-1.0658141e-14 16,-1.0658141e-14 Z M16,29.7142857 C8.42580915,29.7142857 2.28571429,23.5741909 2.28571429,16 C2.28571429,8.42580915 8.42580915,2.28571429 16,2.28571429 C23.5741909,2.28571429 29.7142857,8.42580915 29.7142857,16 C29.7142857,19.6372547 28.2693919,23.125537 25.6974644,25.6974644 C23.125537,28.2693919 19.6372547,29.7142857 16,29.7142857 Z"
        id="Style"
      />
      <polygon
        fill="currentColor"
        id="Rectangle"
        points="13.3333333 9.33333333 22.2790715 16 13.3333333 22.6666667"
      />
    </Icon>
  );
}
